/*
 * Copyright (c) 2024 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain
 * proprietary information of OCLC, Inc. and shall not be disclosed in whole or in
 * any part to any third party or used by any person for any purpose, without written
 * consent of OCLC, Inc.  Duplication of any portion of these  materials shall include this notice.
 *
 */

import { styled } from '@mui/material/styles';
import { Alert, IconButton } from '@mui/material';

const StyledAlert = styled(Alert)(({ theme }) => ({
  borderLeftWidth: '6px',
  padding: '3px 7px 3px 8px',

  '& .MuiAlert-icon': {
    marginRight: '3px',

    '& .MuiSvgIcon-root': {
      fontSize: '1.25rem',
    },
  },

  '& .MuiAlert-message': {
    ...theme.typography.body2,
    padding: '5px',
    wordBreak: 'break-word',
  },

  '& .MuiAlert-action': {
    paddingLeft: '4px',
  },
}));

const StyledIconButton = styled(IconButton)(() => ({
  padding: 4,
}));

export { StyledAlert, StyledIconButton };
